// Mock data for Gävles Autodepå

export const businessInfo = {
  name: "Gävles Autodepå",
  tagline: "Bilfix på hjul",
  phone: "070-738 69 69",
  email: "info@gavles-autodepa.se",
  address: {
    street: "Ängsullsvägen 26",
    postal: "806 36 Gävle",
    full: "Ängsullsvägen 26, 806 36 Gävle"
  },
  hours: {
    weekdays: "Måndag–Fredag: 08–18",
    saturday: "Lördag: Stängt",
    sunday: "Söndag: Stängt"
  },
  about: "Gävles Autodepå är en bilverkstad i Gävle som erbjuder professionell service och underhåll av fordon. Med kunnig personal och hög servicenivå hjälper de kunder med allt från felsökning till reparationer. Fokus ligger på kvalitet, noggrannhet och att kunden ska känna sig trygg genom hela processen."
};

export const services = [
  {
    id: 1,
    title: "Rullande Bilverkstad",
    description: "Vi erbjuder rullande verkstad och kommer direkt till dig, oavsett om du står hemma, på jobbet eller längs vägen. Perfekt vid akuta problem eller när du inte har möjlighet att ta dig till en verkstad. Vi utför service, felsökning och reparationer på plats för att göra det så smidigt som möjligt för dig.",
    icon: "Truck"
  },
  {
    id: 2,
    title: "Däckbyte & Däckservice",
    description: "Vi erbjudar professionell däckservice och hjälper dig med allt från däckbyte till försäljning och montering av nya däck. Vi kan beställa hem däck efter behov och säkerställer att de monteras och balanseras korrekt för bästa säkerhet och prestanda. Hos oss får du kvalitet till bra pris och hjälp genom hela processen.",
    icon: "CircleDot"
  },
  {
    id: 3,
    title: "Reparationer",
    description: "Vi utför allt från mindre reparationer till mer avancerade arbeten på din bil. Med rätt kunskap och utrustning ser vi till att din bil blir åtgärdad på ett korrekt och hållbart sätt. Vi arbetar effektivt utan att tumma på kvaliteten, vilket gör att du snabbt får tillbaka din bil i bästa skick.",
    icon: "Wrench"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "5 Års Erfarenhet",
    description: "Gedigen kunskap och professionellt hantverk",
    icon: "Award"
  },
  {
    id: 2,
    title: "1000+ Nöjda Kunder",
    description: "Över tusen kunder litar på oss",
    icon: "Users"
  },
  {
    id: 3,
    title: "Återkommande Kunder",
    description: "Hög andel kunder som kommer tillbaka – det säger allt",
    icon: "RefreshCw"
  },
  {
    id: 4,
    title: "Endast Kvalitetsdelar",
    description: "Högkvalitativa delar till bra pris – aldrig lågkvalitativt",
    icon: "CheckCircle"
  },
  {
    id: 5,
    title: "Snabb Service",
    description: "Vi värdesätter din tid och arbetar effektivt",
    icon: "Zap"
  },
  {
    id: 6,
    title: "Rullande Verkstad",
    description: "Vi kommer till dig när du behöver det",
    icon: "Truck"
  }
];

export const processSteps = [
  {
    id: 1,
    step: "01",
    title: "Ring Oss",
    description: "Kontakta oss på 070-738 69 69 så bokar vi en tid"
  },
  {
    id: 2,
    step: "02",
    title: "Vi Undersöker",
    description: "Noggrann diagnos av din bil – på verkstaden eller hos dig"
  },
  {
    id: 3,
    step: "03",
    title: "Vi Löser Problemet",
    description: "Professionell reparation med kvalitetsdelar"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Google Recension",
    rating: 5,
    text: "Toppen service, kunnig personal allt perfekt.",
    platform: "google",
    date: "Google"
  },
  {
    id: 2,
    name: "Facebook Recension",
    rating: 5,
    text: "Otroligt duktig och noga utfört bromsbyte! Mycket nöjd! 🤩",
    platform: "facebook",
    date: "Facebook"
  },
  {
    id: 3,
    name: "Facebook Recension",
    rating: 5,
    text: "Bästa servicen om man behöver hjälp med bilar.",
    platform: "facebook",
    date: "Facebook"
  }
];

export const images = {
  hero: "https://images.pexels.com/photos/33814734/pexels-photo-33814734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  workshop: "https://images.pexels.com/photos/33814736/pexels-photo-33814736.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  services: [
    "https://images.unsplash.com/photo-1767339736233-f4b02c41ee4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxtZWNoYW5pYyUyMHdvcmtpbmclMjBlbmdpbmV8ZW58MHx8fHwxNzc0ODg0OTkzfDA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/7564861/pexels-photo-7564861.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/7564871/pexels-photo-7564871.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  ],
  tools: "https://images.unsplash.com/photo-1749498891468-88f77a8d745b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjYXIlMjB3b3Jrc2hvcCUyMGdhcmFnZXxlbnwwfHx8fDE3NzQ4ODQ5ODh8MA&ixlib=rb-4.1.0&q=85",
  garage: "https://images.unsplash.com/photo-1653580170619-927a7e52d084?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjYXIlMjB3b3Jrc2hvcCUyMGdhcmFnZXxlbnwwfHx8fDE3NzQ4ODQ5ODh8MA&ixlib=rb-4.1.0&q=85"
};

export const partners = [
  {
    id: 1,
    name: "Xenonkungen",
    description: "Vi samarbetar med Xenonkungen – specialister på fordonsbelysning och uppgradering av bilars ljussystem. Genom samarbetet kan vi erbjuda lösningar inom extraljus, rampljus och modern belysning som förbättrar både säkerhet och körupplevelse.",
    logo: "https://customer-assets.emergentagent.com/job_bilservice-gavle/artifacts/auizdful_ChatGPT%20Image%20Mar%2030%2C%202026%2C%2011_55_06%20PM.png",
    website: "https://xenonkungen.se"
  },
  {
    id: 2,
    name: "Bilnyckel Akuten Sverige AB",
    description: "Bilnyckel Akuten Sverige AB är specialister på bilnycklar och fordonslås. Genom samarbetet kan vi erbjuda snabb och professionell hjälp med allt från nyckelprogrammering till akuta problem där bilnyckeln tappats bort eller slutat fungera. De erbjuder mobil service och arbetar med modern utrustning för att hjälpa kunder direkt på plats.",
    logo: "https://customer-assets.emergentagent.com/job_bilservice-gavle/artifacts/2ot9us0q_ChatGPT%20Image%20Feb%2021%2C%202026%2C%2012_31_31%20PM.png",
    website: "https://bilnyckelakuten.se"
  }
];
